import React, { useMemo, useContext } from 'react'
import { ConfigContext } from 'contexts/ConfigContext'
import { Button, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap'
import objectPath from 'object-path'
import FeatherIcon from 'feather-icons-react'
import '../score.css'
import dayjs from 'dayjs'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import { checkIsWarning } from '../Validation'

const ShowScore = ({
  fieldKey,
  uischema,
  scoreIndex,
  deleteScore,
  editScore,
  scores,
  warning,
  isReadOnly,
  warningChart,
}) => {
  const { dateFormat } = useTimeFormat()
  const scoreActionUpdate = objectPath.get(uischema, 'scoreAction.update') || {}
  const scoreActionDelete = objectPath.get(uischema, 'scoreAction.delete') || {}
  const fullConfig = objectPath.get(uischema, 'scoreConfig')
  const scoreSetting = objectPath.get(uischema, 'scoreSetting')
  const scoreConfig = fullConfig.filter(
    ({ isDate, isTime }) => !isDate && !isTime
  )

  const configContext = useContext(ConfigContext)
  const { layoutType } = configContext.state

  const colorByTheme = useMemo(
    () => (layoutType === 'dark' ? '#adb7be' : '#495057'),
    []
  )

  const scoreValueStyle = useMemo(() => {
    if (scoreSetting?.scoreWidth) {
      return {
        width: scoreSetting.scoreWidth,
      }
    }
    return {}
  }, [scoreSetting?.scoreWidth])

  const dateChart = useMemo(() => {
    return fullConfig.find(({ isDate, enabled }) => isDate && enabled) || {}
  }, [])

  const timeChart = useMemo(() => {
    return fullConfig.find(({ isTime, enabled }) => isTime && enabled) || {}
  }, [])

  const { isCurrentTime } = timeChart
  const { isDate } = dateChart
  const dateName = objectPath.get(dateChart, 'name')
  const timeName = objectPath.get(timeChart, 'name')
  const foundScore = scores.find((item) => objectPath.get(item, dateName)) || {}
  const dateValue = objectPath.get(foundScore, dateName)

  const TooltipWarning = ({ isWarning, children }) => {
    let { name, ageRange, operator, value, icd10Code, disease, gender } =
      isWarning

    return (
      <OverlayTrigger
        key={name}
        placement="bottom"
        overlay={
          <Tooltip id={`tooltip-${name}`}>
            <ul className="pl-3 pr-0 py-0 my-0 text-left">
              <li className="p-0">
                มีค่า {operator} {value}
              </li>
              {gender && <li>เพศ {gender}</li>}
              {ageRange && <li>ช่วงอายุ {ageRange}</li>}
              {icd10Code && (
                <li>
                  โรค {icd10Code} : {disease}
                </li>
              )}
            </ul>
          </Tooltip>
        }
      >
        {children}
      </OverlayTrigger>
    )
  }

  return (
    <div>
      <div>
        {isDate && (
          <div className="body-box d-flex">
            <div
              className="d-flex border w-100 p-2 align-items-center"
              style={{ color: colorByTheme }}
            >
              {dayjs(dateValue).format(dateFormat)}
            </div>
          </div>
        )}
        {!isCurrentTime ? (
          <>
            <div className="d-flex">
              {scores.map((score) => {
                let scoreValue = objectPath.get(score, [timeName])
                let timeValue = scoreValue
                return (
                  <div
                    className="sub-box"
                    style={{ ...scoreValueStyle, color: colorByTheme }}
                  >
                    {timeValue}
                  </div>
                )
              })}
            </div>
            {scoreConfig.map((config) => {
              let { group, name, data, enabled } = config
              if (!enabled) return
              return (
                <div className="d-flex">
                  {scores.map((score) => {
                    let scoreValue = objectPath.get(score, [name])
                    let isWarning = checkIsWarning(
                      warningChart,
                      name,
                      scoreValue
                    )

                    if (group) {
                      return (
                        <div class="expander">
                          {data.map(({ name, enabled }) => {
                            if (!enabled) return
                            let scoreValue = objectPath.get(score, [name])
                            let isWarning = checkIsWarning(
                              warningChart,
                              name,
                              scoreValue
                            )
                            if (isWarning && scoreValue) {
                              return (
                                <TooltipWarning isWarning={isWarning}>
                                  <div
                                    className={`sub-box ${
                                      isWarning ? 'text-danger' : ''
                                    }`}
                                    style={{
                                      ...scoreValueStyle,
                                      color: colorByTheme,
                                    }}
                                  >
                                    {scoreValue}
                                  </div>
                                </TooltipWarning>
                              )
                            }

                            return (
                              <div
                                className={`sub-box ${
                                  isWarning ? 'text-danger' : ''
                                }`}
                                style={scoreValueStyle}
                              >
                                {scoreValue}
                              </div>
                            )
                          })}
                        </div>
                      )
                    }
                    if (isWarning && scoreValue) {
                      return (
                        <TooltipWarning isWarning={isWarning}>
                          <div
                            className={`sub-box ${
                              isWarning ? 'text-danger' : ''
                            }`}
                            style={{ ...scoreValueStyle, color: colorByTheme }}
                          >
                            {scoreValue}
                          </div>
                        </TooltipWarning>
                      )
                    }
                    return (
                      <div
                        className={`sub-box ${isWarning ? 'text-danger' : ''}`}
                        style={{ ...scoreValueStyle, color: colorByTheme }}
                      >
                        {scoreValue}
                      </div>
                    )
                  })}
                </div>
              )
            })}
          </>
        ) : (
          <>
            {scoreConfig.map((config, index) => {
              let { group, name, data, enabled } = config
              let scoreValue = objectPath.get(scores, [index, name])
              let isWarning = objectPath.get(warning, [index, name])

              if (!enabled) return
              if (group) {
                return (
                  <div>
                    {data.map(({ name, enabled }) => {
                      if (!enabled) return
                      let scoreValue = objectPath.get(scores, [index, name])
                      let isWarning = checkIsWarning(
                        warningChart,
                        name,
                        scoreValue
                      )
                      if (isWarning && scoreValue) {
                        return (
                          <TooltipWarning isWarning={isWarning}>
                            <div
                              className={`sub-box ${
                                isWarning ? 'text-danger' : ''
                              }`}
                              style={{
                                ...scoreValueStyle,
                                color: colorByTheme,
                              }}
                            >
                              {scoreValue}
                            </div>
                          </TooltipWarning>
                        )
                      }
                      return (
                        <div
                          className={`sub-box ${
                            isWarning ? 'text-danger' : ''
                          }`}
                          style={{ ...scoreValueStyle, color: colorByTheme }}
                        >
                          {scoreValue}
                        </div>
                      )
                    })}
                  </div>
                )
                if (isWarning && scoreValue) {
                  return (
                    <TooltipWarning isWarning={isWarning}>
                      <div
                        className={`sub-box ${isWarning ? 'text-danger' : ''}`}
                        style={{ ...scoreValueStyle, color: colorByTheme }}
                      >
                        {scoreValue}
                      </div>
                    </TooltipWarning>
                  )
                }
              }
              return (
                <div
                  className={`sub-box ${isWarning ? 'text-danger' : ''}`}
                  style={scoreValueStyle}
                >
                  {scoreValue}
                </div>
              )
            })}
          </>
        )}
      </div>
      {!isReadOnly && (
        <div className="d-flex align-items-end justify-content-end">
          <div className="d-flex">
            {scoreActionUpdate?.isEnabled && (
              <div className="mb-2">
                <Button
                  id={`${fieldKey}-edit`}
                  className="score-button"
                  variant="outline-warning"
                  onClick={() => editScore(scoreIndex)}
                >
                  <FeatherIcon icon="edit" size="16" />
                </Button>
              </div>
            )}
            {scoreActionDelete?.isEnabled && (
              <div className="mx-1">
                <Button
                  id={`${fieldKey}-delete`}
                  className="score-button"
                  variant="outline-danger"
                  onClick={() => deleteScore(scoreIndex)}
                >
                  <FeatherIcon icon="trash" size="16" />
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
export default ShowScore
